<template>
  <vs-popup id="popupRiskInfo2" title="중대성(강도)" :active.sync="popupActiveSync">
    <div class="p-4">
      <div class="risk-info-header">
        <span style="border-right: none;">중대성(강도)</span>
        <span>내용</span>
      </div>
      <div>
        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">3</span>
          <span style="border-top: none; display: block;">사망중대한 상해 또는 생명을 위협하는 직업성 질병 초래 위험</span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">2</span>
          <span style="border-top: none; display: block;">의학적인 치료를 요하는 상해 또는 장애를 일으키는 질병</span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">1</span>
          <span style="border-top: none; display: block;">근로자에게 유해·위험 정보제공 및 교육 등이 필요한 상태</span>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopupRiskInfoBsgs2',
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-info-header,
.risk-info-body {
  display: grid;
  grid-template-columns: 109px 1fr;
}
.risk-info-body {
  span {
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
.risk-info-header {
  //display: grid;
  //grid-template-columns: 109px 109px 109px 572px 236px;
  //grid-template-areas: "A A A B C" "D E F B C";
  //grid-template-rows: 40px 40px;
  background-color: #F9F9F9;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border: 1px solid #DEDEDE;
  }
}
</style>
<style>

#popupRiskInfo2 > .vs-popup {
  width: 650px !important;
}

#popupRiskInfo2 > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskInfo2 > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
